import { useHighlightedText } from 'homepage/libs/hooks'

import * as styles from './description.styles'

export const HeroDescription = ({
  description,
  highlighted,
}: {
  description: string
  highlighted?: string
}) => {
  const { before, highlight, after } = useHighlightedText(
    description,
    highlighted
  )

  if (!highlight) {
    return <h1 css={styles.heroDescription}>{description}</h1>
  }

  return (
    <p css={styles.heroDescription}>
      {before}
      <strong css={styles.highlighted}>{highlight}</strong>
      <br />
      {after}
    </p>
  )
}
